import React from 'react';

const Eye = (props: { className: any, onClick?: any }) => {
  const { className, onClick } = props;

  const handleOnClick = (e: any) => {

    if (onClick) onClick(true);
  }

  return (

    <svg id="Layer_2" className={className} onClick={handleOnClick} data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.19 11.09">
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path className="cls-1" d="m0,5.24c.05-.15.1-.31.17-.46.15-.36.39-.65.71-.85,1.24-.77,2.47-1.58,3.75-2.3C6.89.37,9.34-.12,11.92.03c2.37.14,4.55.85,6.55,2.13.91.58,1.83,1.13,2.74,1.71.6.38.95.92.97,1.64.02.67-.24,1.24-.8,1.6-1.49.95-2.94,1.98-4.54,2.73-2.39,1.12-4.9,1.48-7.52,1.15-2.02-.25-3.87-.94-5.59-2.02-.9-.57-1.8-1.13-2.7-1.68-.52-.32-.88-.76-1.01-1.37,0-.02-.02-.03-.03-.05,0-.2,0-.4,0-.61Zm11.11-3.16c-1.91,0-3.47,1.54-3.48,3.45,0,1.92,1.54,3.49,3.46,3.49,1.91,0,3.47-1.55,3.48-3.45,0-1.92-1.54-3.48-3.46-3.49Zm3.1,7.22c.07-.01.12-.02.17-.03.87-.24,1.72-.54,2.5-1,1.19-.7,2.37-1.44,3.54-2.17.52-.32.52-.76-.01-1.09-.82-.51-1.65-1.01-2.46-1.54-1.1-.71-2.26-1.27-3.53-1.61-.06-.02-.13-.03-.24-.05,2.32,2,2.35,5.52.02,7.5Zm-6.29.02s.02-.04.03-.07c-2.24-1.93-2.29-5.49.03-7.44-.08.02-.14.02-.19.04-.84.23-1.66.52-2.41.96-1.22.72-2.42,1.47-3.62,2.21-.5.31-.49.75,0,1.07.52.33,1.04.65,1.56.97.94.58,1.85,1.22,2.87,1.63.56.23,1.15.42,1.72.63Z" />
          <path className="cls-1" d="m12.48,5.54c0,.77-.62,1.39-1.39,1.39-.76,0-1.39-.63-1.38-1.39,0-.76.62-1.38,1.38-1.38.77,0,1.39.62,1.39,1.38Z" />
        </g>
      </g>
    </svg>
  );
};
export default Eye;
